<template>
  <div>
    <TitleWrapper
      :filter-option="false"
      title="PERSONAL_INFO"
      tooltip-title="PERSONAL_INFO"
      :display-breadcrumb="true"
    />
    <div class="bg-primary-white p-3 md:p-7 border rounded-lg border-gray-200">
      <InputFieldWrapper>
        <InputBox
          type="text"
          name="First Name"
          title="First Name"
          label="First Name"
          placeholder="First Name"
        />
        <InputBox
          type="text"
          name="Last Name"
          title="Last Name"
          label="Last Name"
          placeholder="Last Name"
        />
        <UiSingleSelect title="Gender" :options="genderArray" />
        <UiSingleSelect title="BL_GROUP" :options="bloodGroupArray" />
        <UiDatePicker title="DOB" />
        <UiSingleSelect title="Religion" :options="religion" />
        <InputBox
          type="text"
          name="Nationality"
          title="Nationality"
          label="Nationality"
          placeholder="American"
        />
      </InputFieldWrapper>
      <button
        class="mt-5 focus:outline-none focus:shadow-md ltr:text-base rtl:text-sm text-white font-rubik flex w-full md:w-40 py-2 justify-center primary-button"
      >
        Save Changes
      </button>
    </div>
  </div>
</template>

<script>
import TitleWrapper from '@components/TitleWrapper.vue'
import InputBox from '@components/UiElements/UiInputBox.vue'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import UiDatePicker from '@components/UiElements/UiDatePicker.vue'
import { mapActions } from 'vuex'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  components: {
    TitleWrapper,
    InputBox,
    UiSingleSelect,
    UiDatePicker,
    InputFieldWrapper,
  },
  data() {
    return {
      genderArray: ['male', 'female'],
      bloodGroupArray: ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'],
      religion: ['Islam', 'Christianity', 'Hinduism'],
    }
  },
  mounted() {
    this.setRightbarData()
  },
  methods: {
    ...mapActions('layout', ['setRightbarContent']),
    setRightbarData(length = 0) {
      const rightBarContent = {
        header: {
          title: 'Settings',
        },
        profileInfo: [
          {
            isUploadButton: true,
            imageUrl: this.currentStudent?.profile?.image || null,
          },
        ],
        bargraph: [
          {
            barGraphTitle: this.$t('rightBar.Active Hours'),
            barGraphList: [
              { value: 2, color: '#267C26', tooltip: 'BIO' },
              { value: 12, color: '#267C26', tooltip: 'CHEM' },
              { value: 10, color: '#267C26', tooltip: 'PHY' },
              { value: 18, color: '#267C26', tooltip: 'MATH' },
              { value: 6, color: '#267C26', tooltip: 'ENG' },
              { value: 16, color: '#267C26', tooltip: 'URD' },
              { value: 4, color: '#267C26', tooltip: 'PAK' },
            ],
          },
        ],
      }
      this.setRightbarContent(rightBarContent)
    },
  },
}
</script>
